import { Typography } from '@mui/material';
import React from 'react';
import { ErrorReference, GraphQlRequestErrorCode } from '../../../../api/types';
import { useAuthenticationServiceContext } from '../../../../context/contexts';
import { Error } from './Error';
import ErrorTechnicalDetails from './ErrorTechnicalDetails';

interface NoAccountRegisteredErrorProps {
  errorCode: GraphQlRequestErrorCode;
  errorReference: ErrorReference | null;
}

const NoAccountRegisteredErrorComponent = (
  props: NoAccountRegisteredErrorProps
) => {
  const { errorCode, errorReference } = props;
  const authService = useAuthenticationServiceContext();
  const { email } = authService.currentUser ?? { email: '' };

  return (
    <Error
      title={{
        key: 'pages:errorBoundary.noAccountRegistered',
        options: { email: email ?? '' },
      }}
      message={(t) => (
        <>
          <Typography variant="h5">
            {t('pages:errorBoundary.contactAdministrator')}
          </Typography>
          <ErrorTechnicalDetails
            errorCode={errorCode}
            errorReference={errorReference}
          />
        </>
      )}
    />
  );
};

export default NoAccountRegisteredErrorComponent;
